import { Fragment, useState, KeyboardEvent, MouseEvent, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// mui
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Drawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
// component
import SFHamburgerIcon from '@/component/icons/sf-hamburger-icon';
import DownloadDrawer from '../wallet/download-drawer';
import SumMyCoin from '../wallet/SumMyCoin';
import AvatarForm from '../mui/AvatarForm';
// hook
import { useWeb3AuthConnect, useWeb3AuthUser } from '@web3auth/modal/react';
import { useWeb3AuthDisconnect } from '@web3auth/modal/react';
import { useWeb3 } from '@/contexts/web3Provider';
// lib & store
import { fontWeight, inter } from '@/theme';
import { SFPalette } from '@/lib/color';
import { useUserInfo } from '@/store/zustand/store';
import { ShortenAddr } from '@/lib/Shorten';
// icon & img
import SFDownloadIcon from '../icons/sf-download-icon';
import SFSendIcon from '../icons/sf-send-icon';
import ArrowLinkButton from './arrow-link-button';
import ImgShuffle from '@/assets/images/shuffle-logo-light.svg';
import { maskingEmail } from '@/lib/Masking';

export default function SideDrawer() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const [isDownloadDrawerOpen, setIsDownloadDrawerOpen] = useState(false);
  const userInfo = useUserInfo();
  const toggleDrawer = (open: boolean) => (event: KeyboardEvent | MouseEvent) => {
    setOpen(open);
  };
  const [address, setAddress] = useState('');

  const { isConnected } = useWeb3AuthConnect();
  const { userInfo: web3authUserInfo, getUserInfo, loading: userInfoLoading, error: userInfoError } = useWeb3AuthUser();
  const { address: addr } = useWeb3();

  // address 상태를 로컬 state와 동기화
  useEffect(() => {
    if (addr) {
      setAddress(addr);
    }
  }, [addr]);

  // 디버깅을 위한 로그
  // useEffect(() => {
  //   if (isConnected && web3authUserInfo) {
  //     console.log(`isConnected: ${isConnected}`);
  //     console.log(`addr from context: ${addr}`);
  //     console.log(`local address: ${address}`);
  //     console.log(`wagmiAddress: ${wagmiAddress}`);
  //     console.log(`addr: ${addr}`);
  //     console.log(`userInfo: ${JSON.stringify(web3authUserInfo, null, 4)}`);
  //   }
  // }, [isConnected, web3authUserInfo, addr, address, wagmiAddress]);

  return (
    <Fragment>
      <IconButton onClick={toggleDrawer(true)} sx={{ px: 0 }}>
        <SFHamburgerIcon />
      </IconButton>

      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            width: `calc(100% - 24px)`,
            mr: 2,
          },
        }}
      >
        <Box bgcolor={theme.palette.primary.main}>
          <Box display="flex" flexDirection="column" height="100%" gap={8}>
            <Container maxWidth="sm">
              <IconButton
                onClick={toggleDrawer(false)}
                sx={{
                  position: 'absolute',
                  top: 2,
                  right: 2,
                }}
              >
                <CloseIcon
                  sx={{
                    color: 'white',
                  }}
                />
              </IconButton>
              <Box mb={2.5} mt={4} textAlign="center">
                <ImgShuffle />
              </Box>
            </Container>
            <Box
              pt={5}
              left={0}
              bottom={0}
              flex={1}
              width="100%"
              sx={{
                bgcolor: 'white',
                '&': {
                  borderTopLeftRadius: '30px',
                  borderTopRightRadius: '30px',
                },
              }}
            >
              <Container
                maxWidth="sm"
                sx={{
                  position: 'relative',
                }}
              >
                <AvatarForm
                  sxOptions={{
                    width: 100,
                    height: 100,
                    border: '4px solid white',
                    position: 'absolute',
                    top: -90,
                    left: '50%',
                    transform: 'translateX(-50%)',
                  }}
                />
                <Box pt={3}>
                  <Typography mb={1} variant="h6" color="black" textAlign="center" fontWeight={fontWeight.Bold}>
                    {maskingEmail(web3authUserInfo?.email) || 'member'}
                  </Typography>
                  <Typography
                    variant="body1"
                    color={SFPalette.grey2}
                    textAlign="center"
                    fontWeight={fontWeight.Bold}
                    fontFamily={inter.style.fontFamily}
                    mb={1}
                  >
                    {/* <SumMyCoin /> */}
                  </Typography>
                  <Typography
                    variant="body2"
                    color={SFPalette.lightGrey2}
                    textAlign="center"
                    fontWeight={fontWeight.Medium}
                    fontFamily={inter.style.fontFamily}
                    mb={3}
                  >
                    {ShortenAddr(address)}
                  </Typography>
                </Box>
                <Stack direction="row" alignItems="center" justifyContent="center" gap={1} mb={5}>
                  <Button
                    size="large"
                    variant="outlined"
                    sx={{
                      borderRadius: '100px !important',
                      minWidth: '100px',
                    }}
                    startIcon={<SFDownloadIcon color={theme.palette.primary.main} />}
                    onClick={() => {
                      setIsDownloadDrawerOpen(true);
                    }}
                  >
                    <Typography variant="body2" fontWeight={700}>
                      받기
                    </Typography>
                  </Button>
                  <Button
                    size="large"
                    variant="outlined"
                    sx={{
                      borderRadius: '100px !important',
                      minWidth: '100px',
                    }}
                    startIcon={<SFSendIcon color={theme.palette.primary.main} />}
                    onClick={() => {
                      navigate('/sendForm');
                      // setIsDownloadDrawerOpen(true);
                    }}
                  >
                    <Typography variant="body2" fontWeight={700}>
                      보내기
                    </Typography>
                  </Button>
                </Stack>
                <Stack mb={8}>
                  {[
                    {
                      type: 'internal',
                      name: 'NFT',
                      src: '/nft',
                    },
                    // {
                    //   type: 'internal',
                    //   name: '활동',
                    //   src: '',
                    // },
                    // {
                    //   type: 'external',
                    //   name: '스테이킹',
                    //   src: 'https://taycan-wallet.hupayx.io/',
                    // },
                    {
                      type: 'external',
                      name: 'Polygonscan 바로가기',
                      src: address ? `https://polygonscan.com/address/${address}` : `https://polygonscan.com/`,
                    },
                    // {
                    //   type: 'external',
                    //   name: 'Cosmosscan 바로가기',
                    //   src: address
                    //     ? `https://taycan-cosmoscan.hupayx.io/accounts/${evmosAddr}`
                    //     : `https://taycan-cosmoscan.hupayx.io`,
                    // },
                    // {
                    //   type: 'external',
                    //   name: '트라이스 마켓 바로가기',
                    //   src: `https://metamask.app.link/dapp/www.trice.ai/`,
                    // },
                  ].map((item, index) => (
                    <ArrowLinkButton
                      key={(item.name + '-', index)}
                      onClick={() => {
                        if (item.type === 'external') {
                          // TODO 모바일에서 확인
                          // 내 지갑 주소넣어서 확인
                          window.open(item.src);
                          // window.open(item.src);
                        } else {
                          navigate(item.src);
                        }
                      }}
                      buttonProps={{
                        sx: {
                          width: '100%',
                          p: 0.5,
                        },
                      }}
                      stackProps={{
                        width: '100%',
                        justifyContent: 'space-between',
                        p: 2.5,
                        bgcolor: SFPalette.lightGrey3,
                        borderRadius: 2,
                      }}
                      typographyProps={{
                        variant: 'subtitle2',
                      }}
                    >
                      {item.name}
                    </ArrowLinkButton>
                  ))}
                </Stack>
                <DownloadDrawer
                  open={isDownloadDrawerOpen}
                  onClose={() => {
                    setIsDownloadDrawerOpen(false);
                  }}
                />
              </Container>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Fragment>
  );
}
